import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";
import {Link} from "react-router-dom";
import {ALL_FIBER} from "../../../../components/coverageMap/CoverageMap.ts";
import CoverageMapContainer from "../../../../components/coverageMap/CoverageMapContainer.tsx";
import OrderAddressSearchComponent from "../../../../components/order/OrderAddressSearchComponent.tsx";
import {DispatchHighLightAddressSearchEvent} from "../../../../util/events.ts";

export default function KanJegFaa1000MbitArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className="article">
                    <div className="paragraph">
                        <p>
                            Vi leverer internet via <Link to="/bredbaand/fibernet">fiber</Link> og <Link to="/bredbaand/kabel-tv-stik">kabel-tv-stikket</Link> samt <Link to="/bredbaand/5g-internet">5G-internet</Link> til store dele af Danmark og udvider hele tiden vores dækning.
                        </p>
                        <p>
                            På fibernettet og internet via kabel-tv-stikket kan vi levere 1.000 Mbit.
                            Hvad du kan få af hastighed og teknologi afhænger af infrastrukturen i dit område.
                            Det varierer nemlig, om der er gravet kabler til internet via fibernet eller kabel-tv-stikket ned rundt omkring i Danmark.
                        </p>
                        <p>
                            Med 5G-internet afhænger din hastighed af mobildækningen på din adresse.
                            Signalet til 5G-internet kommer nemlig fra TDC NET&rsquo;s mobilsignal.
                            Styrken på mobilsignalet i dit område afgør, hvilken hastighed du kan få.
                        </p>
                        <p>
                            Tjek hvilken hastighed du kan få:
                        </p>
                        <OrderAddressSearchComponent/>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>
                            Hvilken hastighed garanterer I?
                        </h2>
                        <p>
                            På fibernet og internet via kabel-tv-stikket garanterer vi 90% af hastigheden, hvis du bruger et netværkskabel &ndash; både på download og upload.
                            Dvs. hvis du har en forbindelse på 1000/1000 Mbit og tester din hastighed med et netværkskabel direkte fra routeren til computeren, vil du kunne trække 900/900 Mbit.
                        </p>
                        <p>
                            Du kan <Link to="/hjaelp/internet-og-wifi/hastighedstest">læse mere om hastighedstest lige her!</Link>
                        </p>
                        <p>
                            På 5G-internet er du garanteret en hastighed inden for et bestemt interval.
                            Intervallet afhænger af mobildækningen i dit område, da 5G-internet kommer igennem mobilsignalet.
                            På 5G-internet er der følgende Mbit-hastighedsintervaller:
                        </p>
                        <ul className="list list--bullet list--compact">
                            <p>
                                De forskellige intervaller er:
                            </p>
                            <li>
                                <p>1000-2000 Mbit</p>
                            </li>
                            <li>
                                <p>600-1000 Mbit</p>
                            </li>
                            <li>
                                <p>200-600 Mbit</p>
                            </li>
                            <li>
                                <p>100-200 Mbit</p>
                            </li>
                            <li>
                                <p>50-100 Mbit</p>
                            </li>
                            <li>
                                <p>30-50 Mbit</p>
                            </li>
                            <li>
                                <p>20-30 Mbit</p>
                            </li>
                            <li>
                                <p>10-20 Mbit</p>
                            </li>
                            <li>
                                <p>5-10 Mbit</p>
                            </li>
                            <li>
                                <p>2-5 Mbit</p>
                            </li>
                        </ul>

                        <p>
                            Hvis du generelt vil læse mere om <Link to="/hjaelp/internet-og-wifi/internethastigheder-og-datamaengder">internethastigheder og datamængder</Link>, kan du gøre det her.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>
                            Vil du også have 1000 Mbit?
                        </h2>
                        <p>
                            <button
                                className={'link'}
                                onClick={() => DispatchHighLightAddressSearchEvent(true)}
                            >
                                Tjek din adresse her
                            </button>{' '}
                            og se, hvad vi kan levere til dig.
                        </p>
                    </div>
                </div>

                <div className="article article--connect">
                    <div className="paragraph">
                        <h2 className={'align-center'}>Dækningskort</h2>
                        <p className={'align-center'}>
                            På vores dækningskort kan du se, hvordan vi dækker Danmark.
                        </p>
                        <CoverageMapContainer regionPreset={ALL_FIBER} fiberMapOnly={false} static={false}/>
                        <p className={'coverage-map-disclaimer align-center'}>
                            Vi kan ikke garantere at kunne levere til alle adresser i de markerede områder.
                        </p>
                    </div>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "bestilling",
                        "article": "fiber-installation",
                        "name": "Hvordan får jeg installeret fiber?"
                    },
                    {
                        "category": "bestilling",
                        "article": "leveringstid",
                        "name": "Leveringstid på internet"
                    },
                    {
                        "category": "bestilling",
                        "article": "opsig-eksisterende-abonnement",
                        "name": "Skal jeg selv opsige mit eksisterende abonnement?"
                    },
                    {
                        "category": "udstyr",
                        "article": "hvilken-router-foelger-med",
                        "name": "Hvilken router følger med?"
                    }
                ]}
            />
        </>
    )
}
